import {
    GET_BUDGET_FEE_SCHEDULE,
    SET_BUDGET_DATA,
    GET_BUDGET_FEE_SCHEDULE_FAILED,
    SET_PROPERTY_FIELDS,
    SET_LOADING_BUDGET,
    REMOVE_LOADING_BUDGET,
    UPDATE_PRESEIZURE_PACKAGE_FIELD
} from "../../types";
import axios from "axios";
import { setAlert } from "../alert";
import { FDIC_populateBudgetData } from "./FDIC/budget";
import {
    currencyFormat,
    percentageFormat,
    isEmptyObj
} from "@helpers";

export const getBudgetFeeSchedule = payload => async(dispatch) => {
    try {
        const res = await axios.post(
            `/properties/view/${payload.id}/fee_schedule`,
            { ...payload }
        );
        dispatch({
            type: GET_BUDGET_FEE_SCHEDULE,
            payload: res.data
        });
    }
    catch (error) {
        dispatch({ type: GET_BUDGET_FEE_SCHEDULE_FAILED });
    }
};

export const setBudgetData = () => async(dispatch, getState) => {
    try {
        const {
            properties: {
                propertyData: { budget_data },
                propertyFields
            }
        } = getState();

        const BudgetData = Object.keys(budget_data).reduce((object, key) => {
            if (budget_data[key].hasOwnProperty("lines")) {
                object[key] = Object.values(budget_data[key].lines).reduce(
                    (line, key, index, arr) => {
                        line[arr[index].code] = arr[index];

                        return line;
                    },
                    {}
                );
                object[key].totals = budget_data[key].totals;
            }
            else if (key === "SUMMARY") {
                object[key] = budget_data[key];
            }
            return object;
        }, {});

        const { SUMMARY: { total_projected_income_loss: { prior_expenditures: net_income_loss_since_assignment } } } = BudgetData;
        const {
            VALUE: {
                equity: budget_value_equity,
                expenses_as_a_percent_of_appraised_value
            }
        } = budget_data;
        const newPropertyFields = {
            ...propertyFields,
            net_income_loss_since_assignment,
            budget_value_equity,
            expenses_as_a_percentage_of_appraisal_value: (
                expenses_as_a_percent_of_appraised_value * 100
            ).toFixed(2)
        };

        dispatch({
            type: SET_BUDGET_DATA,
            payload: BudgetData
        });

        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        dispatch(
            setAlert("Failed to Set budget" + error.message, "error", 3000)
        );
    }
};

//	DESC: This method will update data on budget table but not budget fields
export const updateBudgetData = BudgetData => async(dispatch) => {
    try {
        let total_operating_and_resolution_expenses = 0;
        let total_resolution_expenses = 0;
        let total_operating_expenses = 0;
        let total_revenue = 0;
        let total_projected_income_loss = 0;

        Object.keys(BudgetData).forEach(type => {
            if (type !== "SUMMARY" && type !== "INCOME") {
                let non_recurring_items = 0;
                let recurring_items = 0;

                Object.values(BudgetData[type]).forEach(item => {
                    if (!item.hasOwnProperty("total")) {
                        non_recurring_items += parseFloat(
                            item.non_recurring_items || 0
                        );
                        recurring_items += parseFloat(
                            item.recurring_items || 0
                        );
                    }
                    else if (item.hasOwnProperty("total")) {
                        const total = non_recurring_items + recurring_items;
                        BudgetData[type].totals = {
                            total_by_type: {
                                ...BudgetData[type].totals.total_by_type,
                                non_recurring_items,
                                recurring_items
                            },
                            total
                        };

                        if (type === "RESOLUTION EXPENSES") {
                            total_resolution_expenses += total;
                        }
                        else if (type === "OPERATING EXPENSES") {
                            total_operating_expenses += total;
                        }
                    }
                });
                total_operating_and_resolution_expenses +=
                    non_recurring_items + recurring_items;
            }
            else if (type === "INCOME") {
                let non_recurring_items = 0;
                let recurring_items = 0;

                Object.values(BudgetData.INCOME).forEach(item => {
                    if (!item.hasOwnProperty("total")) {
                        non_recurring_items += parseFloat(
                            item.non_recurring_items || 0
                        );
                        recurring_items += parseFloat(
                            item.recurring_items || 0
                        );
                    }
                    else if (item.hasOwnProperty("total")) {
                        BudgetData.INCOME.totals = {
                            total_by_type: {
                                ...BudgetData.INCOME.totals.total_by_type,
                                non_recurring_items,
                                recurring_items
                            },
                            total: non_recurring_items + recurring_items
                        };
                    }
                });
                total_revenue += non_recurring_items + recurring_items;
            }
        });

        total_projected_income_loss =
            total_revenue - total_operating_and_resolution_expenses;

        BudgetData.SUMMARY = {
            ...BudgetData.SUMMARY,
            total_revenue: {
                ...BudgetData.SUMMARY.total_revenue,
                recurring_non_recurring_items: total_revenue
            },
            total_operating_and_resolution_expenses: {
                ...BudgetData.SUMMARY
                    .total_operating_and_resolution_expenses,
                recurring_non_recurring_items: total_operating_and_resolution_expenses
            },
            total_resolution_expenses: {
                ...BudgetData.SUMMARY.total_resolution_expenses,
                recurring_non_recurring_items: total_resolution_expenses
            },
            total_operating_expenses: {
                ...BudgetData.SUMMARY.total_operating_expenses,
                recurring_non_recurring_items: total_operating_expenses
            },
            total_projected_income_loss: {
                ...BudgetData.SUMMARY.total_projected_income_loss,
                recurring_non_recurring_items: total_projected_income_loss
            }
        };
        dispatch({
            type: SET_BUDGET_DATA,
            payload: BudgetData
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

//	DESC: updateBudget method will take in an Event and update budget fields. This method will specificly check for fields that depend on other fields to update its value. If field name does not fall into any case, field will be updated just like regular fields

export const updateBudget = event => async(dispatch, getState) => {
    try {
        // 	DESC: errors array will hold custom errors that pass in and throw at the end.
        //	DESC: This errors will acts as warning vs actual error
        let errors = [];

        const name = event.target.name;
        const {
            properties: { propertyFields },
            contacts: { contact }
        } = getState();
        let newPropertyFields = {
            ...propertyFields,
            [name]: event.target.value
        };
        const {
            budget_current_period_length,
            budget_current_period_start_date
        } = newPropertyFields;

        //	DESC: This get a weird situation where checking for an empty date. It returns type of String but length === 0. I did tried check for falsy didn't work. I check for === '', didn't work as well. I improvised checking for String length of 0 and it is working now. I'll comeback and double check later if there a better way to do it.

        switch (name) {
            case "budget_current_period_length":
            case "budget_current_period_start_date": {
                // TODO: FILTER ON ACTIVE PROPERTIES ONLY!
                if (!budget_current_period_length) {
                    // newPropertyFields.budget_current_period_length = BUDGET_INITIAL_PERIOD;

                    //	DESC: If there is no length, then we break out of the logic. This action will just set the current period to empty without throw error.
                    errors.push("Please Add Current Budget Length!");
                    break;
                }
                else if (Math.sign(budget_current_period_length) === -1) {
                    //	DESC: This block will expecting a negative value and throw TypeError - Current Period Length Cannot be negative.
                    throw new TypeError(
                        "Current Period Length Cannot Be Negative."
                    );
                }
                // const phase = "initial";
                //
                // const date_current = new Date(getToday() + "T12:00:00Z");
                // const date_assigned = new Date(assignment_date + "T12:00:00Z");

                if (budget_current_period_start_date) {
                    const date_budget_start_timestamp = new Date(
                        budget_current_period_start_date + "T12:00:00Z"
                    );
                    const date_budget_end = new Date(
                        date_budget_start_timestamp.getTime()
                    );

                    date_budget_end.setMonth(
                        parseFloat(date_budget_start_timestamp.getMonth()) +
                        parseFloat(budget_current_period_length),
                        date_budget_start_timestamp.getDate()
                    );
                    date_budget_end.setDate(
                        parseFloat(date_budget_end.getDate()) - 1,
                        date_budget_start_timestamp.getDate()
                    );
                    newPropertyFields.budget_current_period_end_date = date_budget_end
                        .toISOString()
                        .split("T")[0];
                }

                const newDate =
                    newPropertyFields.budget_current_period_start_date;
                const oldDate = propertyFields.budget_current_period_start_date;

                // {{-- IF MOVING INTO A NEW BUDGET PERIOD, CLEAR EXISTING APPROVALS AND UNLOCK LINE ITEMS --}}
                if (newDate !== oldDate) {
                    newPropertyFields = {
                        ...newPropertyFields,
                        budget_prepared_date: "",
                        budget_submitted_date: "",
                        budget_approved_date: "",
                        budget_concurred_date: "",
                        budget_prepared_by: "",
                        budget_submitted_by: "",
                        budget_approved_by: "",
                        budget_concurred_by: "",
                        budget_prepared_by_name: "",
                        budget_submitted_by_name: "",
                        budget_approved_by_name: "",
                        budget_concurred_by_name: ""
                    };
                }
                break;
            }
            case "budget_prepared_date":
            case "budget_submitted_date":
            case "budget_approved_date":
            case "budget_concurred_date": {
                /*
                    When Approval date is selected - add current user tie to that field
                    This block is checking for newPropertyFields[name] that equal to newPropertyFields.budget_prepared_date for instance
                    `name` will replace date as the last part of string with by to insert name to the field
                    */
                if (newPropertyFields[name]) {
                    newPropertyFields[`${name.replace("date", "by")}`] =
                        contact.id;
                }
                else if (newPropertyFields[name].length === 0) {
                    newPropertyFields[`${name.replace("date", "by")}`] = null;
                }

                /* BUDGET - DETERMINE STATE (draft, submitted, approved) */
                /*
				Default current state at draft and set state when data available
				*/
                let currentState = "draft";
                if (newPropertyFields.budget_concurred_date) {
                    currentState = "concurred";
                }
                else if (newPropertyFields.budget_approved_date) {
                    currentState = "approved";
                }
                else if (newPropertyFields.budget_submitted_date) {
                    currentState = "submitted";
                }
                else if (newPropertyFields.budget_prepared_date) {
                    currentState = "prepared";
                }
                newPropertyFields.budget_state = currentState;
                break;
            }
            default:
                break;
        }
        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });

        //	DESC: Check to see if there is any error inside the errors array and throw them
        if (errors.length > 0) {
            throw new Error(errors.toString());
        }
    }
    catch (error) {
        if (error.name === "Error") {
            dispatch(setAlert(error.message, "warning"));
        }
        else {
            dispatch(setAlert(error.message, "error"));
        }
    }
};

export const clearBudgetData = () => async(dispatch, getState) => {
    try {
        dispatch({ type: SET_LOADING_BUDGET });

        const { propertyBudget: { BudgetData } } = getState();
        const newBudgetData = { ...BudgetData };

        //	DESC: loop method will go through the object and find `recurring_items` , `non_recurring_items`, and `notes` to clear them.
        const loop = object => {
            //	First level Object
             
            for (let key in object) {
                //	Second level Object
                 
                for (let item in object[key]) {
                    //	Check for empty object to prevent undefined error!
                    if (!isEmptyObj(object[key][item])) {
                        if (
                            object[key][item].hasOwnProperty("recurring_items")
                        ) {
                            object[key][item].recurring_items = "0.00";
                        }
                        if (
                            object[key][item].hasOwnProperty(
                                "non_recurring_items"
                            )
                        ) {
                            object[key][item].non_recurring_items = "0.00";
                        }
                        if (object[key][item].hasOwnProperty("notes")) {
                            object[key][item].notes = "";
                        }
                    }
                }
            }
        };
        loop(newBudgetData);
        //	dispatch updateBudgetData to recalculate the budget
        await dispatch(updateBudgetData(newBudgetData));

        dispatch(setAlert("Budget is cleared", "success"));
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
    finally {
        dispatch({ type: REMOVE_LOADING_BUDGET });
    }
};

export const populateNetEquityComment = () => async(dispatch, getState) => {
    try {
        const {
            properties: {
                propertyFields,
                propertyData: {
                    budget_data: {
                        ["NET EQUITY"]: {
                            executive_summary,
                            executive_summary_flp,
                            prepared_by_note,
                            property_expenses,
                            recommendation,
                            recommendation_flp,
                            recommended,
                            sales_related_expenses,
                        }
                    }
                }
            },
            contacts: { contact: { id } }
        } = getState();

        //	new Today in YYYY-MM-DD format
        //	Removed the Time part because backend complains about it
        const today = new Date().toJSON().split("T")[0];

        let newRecommendation = recommendation;
        let newSummary = executive_summary.split(`\\n`).join(`
`);

        const contact_info = await axios.get('/api/user', { withCredentials: true });

        if (propertyFields.net_equity_program === 'FLP') {
            newRecommendation = recommendation_flp,
            newSummary = executive_summary_flp.split(`\\n`).join(`
`);
        }

        const newPropertyFields = {
            ...propertyFields,
            net_equity_recommendation_note: newRecommendation,
            net_equity_executive_summary_note: newSummary,
            net_equity_property_expenses_note: property_expenses,
            net_equity_sales_related_expenses_note: sales_related_expenses,
            net_equity_prepared_date: today,
            net_equity_prepared_by: id,
            net_equity_contact_name: contact_info.data.name,
            net_equity_prepared_by_title: contact_info.data.title,
            net_equity_title_comments_note: propertyFields.preseizure_condition_report_title_notes,
            net_equity_prepared_by_note: prepared_by_note
        };
        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });

        dispatch(setAlert("Net Equity Populated", "success", 2000));
    }
    catch (error) {
        dispatch(setAlert(error.message, "error", 3000));
    }
};

export const populateNetEquitySpecial = () => async(dispatch, getState) => {
    try {
        const {
            preseizure_packages: {
                budget_data,
                data,
            },
        } = getState();

        let specialRecommendation = budget_data["NET EQUITY"].recommendation_special;
        let program = data.net_equity_program === 'FLP' ? 'flp' : 'afp';
        let specialExecutiveSummary = budget_data["NET EQUITY"]['executive_summary_special_'+program].replace(/\\n/g, '\n');

        const newData = {
            ...data,
            net_equity_recommendation_special: specialRecommendation,
            net_equity_executive_summary_note_special: specialExecutiveSummary
        };

        dispatch({
            type: UPDATE_PRESEIZURE_PACKAGE_FIELD,
            payload: newData
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error", 3000));
    }
};

export const populateNetEquityFLP = (event) => async(dispatch, getState) => {
    try {
        const {
            properties: {
                propertyFields,
                propertyData: { budget_data }
            },
        } = getState();

        const newPropertyFields = {
            ...propertyFields,
            net_equity_recommendation: budget_data["NET EQUITY"].recommendation_flp,
            net_equity_executive_summary_note: budget_data["NET EQUITY"].executive_summary_flp
        };

        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error", 3000));
    }
};

export const clearNetEquityComment = () => async(dispatch, getState) => {
    try {
        const {
            properties: {
                propertyFields
                // propertyData :{
                //     budget_data :{
                //         ["NET EQUITY"] :{
                //             executive_summary,
                //             prepared_by_note,
                //             property_expenses,
                //             recommendation,
                //             sales_related_expenses
                //         }
                //     }
                // }
            }
            // contacts :{
            //     contact :{ id }
            // }
        } = getState();

        const newPropertyFields = {
            ...propertyFields,
            net_equity_recommendation_note: "",
            net_equity_recommendation_note_html: "",
            net_equity_title_comments_note: "",
            net_equity_title_comments_note_html: "",
            net_equity_executive_summary_note: "",
            net_equity_executive_summary_note_html: "",
            net_equity_property_expenses_note: "",
            net_equity_property_expenses_note_html: "",
            net_equity_sales_related_expenses_note: "",
            net_equity_sales_related_expenses_note_html: "",
            net_equity_prepared_by: "",
            net_equity_prepared_by_title: "",
            net_equity_prepared_date: "",
            net_equity_prepared_by_note: ""
        };
        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });

        dispatch(setAlert("Net Equity Clear", "success", 2000));
    }
    catch (error) {
        dispatch(setAlert(error.message, "error", 3000));
    }
};

export const populateBudgetData = event => async(dispatch, getState) => {
    try {
        dispatch({ type: SET_LOADING_BUDGET });
        event.persist();

        const { MISC: { APP: { CODE } } } = getState();

        if (CODE === "FDIC") {
            return dispatch(FDIC_populateBudgetData());
        }

        //	DESC: pre-set the errors array and set potential warning to this array and throw them at the end of logic
        // let errors = [];
        const {
            properties: {
                propertyFields: {
                    id,
                    assignment_date,
                    budget_current_period_length,
                    type_primary,
                    type_secondary,
                    value_current_appraised,
                    property_management_occupancy_status,
                    tax_total_due,
                    lot_size,
                    building_size,
                    year_built
                }
            }
        } = getState();

        //  Period will fallback to default value inside env file
        //  on populate, set period to default period
        //  @TODO, passed along data with default period
        const period = budget_current_period_length || 12;

        if (!value_current_appraised) {
            throw new RangeError(
                "Current Valuation Report Value is required to populate Budget Table!"
            );
        }

        const payload = {
            id,
            assignment_date,
            type_primary,
            value_current_appraised,
            property_management_occupancy_status
        };

        await dispatch(getBudgetFeeSchedule(payload));

        const {
            propertyBudget: {
                FeeSchedule: {
                    type,
                    set_up_fee,
                    monthly_admin_management_fee,
                    disposition_fee,
                    appraisal_fee,
                    inspection_fee
                },
                BudgetData
            }
        } = getState();

        const tax_cycles = Math.ceil(period / 12);

        const realtor_disposition =
            Math.ceil(disposition_fee / 10) * 10 * tax_cycles;

        const land_types_sfr = [23];
        // **5405 - Property Taxes**
        const LINE_5405 = {
            non_recurring_items: tax_total_due,
            notes: "Base year taxes due + any delinquent taxes due"
        };

        // **5413 - Grounds**
        /**
         * If the property has no grounds i.e. lot_size = 0, then this will be $0, otherwise, up to 1 acre, $350/month, an extra $100 per acre for every acre after that, capped at $1,750.00/month.
         Note should read: "$###/month (whatever the calculation lands at) for grass cutting, weed abatement, trimming."
         */
        const LINE_5413 = {
            recurring_items: 0,
            non_recurring_items: 0,
            notes: ""
        };
        if (lot_size > 0) {
            let current_sqft = 0;
            let value = LINE_5413.recurring_items;
            //  If building_size is null set to 0 an continue calculation
            if (building_size) {
                current_sqft = building_size;
            }
            else {
                current_sqft = 0;
            }

            switch (type) {
                case "sfr": {
                    if (current_sqft > 0 && current_sqft <= 1500) {
                        value = current_sqft * 0.1;
                    }
                    else {
                        value = 1500 * 0.1 + (current_sqft - 1500) * 0.05;
                    }
                    break;
                }
                case "commercial":
                case '"multi-family"': {
                    value = 350;
                    break;
                }
                case "land": {
                    if (land_types_sfr.includes(type_secondary)) {
                        if (lot_size <= 1) {
                            value = 75;
                        }
                        else if (lot_size > 1) {
                            value = 125;
                        }
                    }
                    else {
                        value = 25 * Math.ceil(lot_size);
                        if (value > 416) {
                            value = 416;
                        }
                    }
                    break;
                }
            }
            const initial_cleanup = Math.ceil((value * 2) / 10) * 10;
            value = Math.ceil(value / 10) * 10;

            if (value > 0) {
                LINE_5413.notes =
                    currencyFormat(value) +
                    "/month for grass cutting, weed abatement, trimming. Plus " +
                    currencyFormat(initial_cleanup) +
                    " initial cleanup";
            }
            LINE_5413.recurring_items = value * period;
            LINE_5413.non_recurring_items = initial_cleanup;
        }

        //  5415 - Misc Operating Expense
        //	CHANGED ON 2019-12-12 PER BT; 1% OF value_current_appraised OR $2000 - WHICHEVER IS GREATER

        const miniumOperatingExpense = 2000;

        const LINE_5415 = {
            recurring_items: miniumOperatingExpense,
            notes: ""
        };

        if (value_current_appraised) {
            const value = value_current_appraised * 0.01;
            LINE_5415.recurring_items =
                value > miniumOperatingExpense ? value : miniumOperatingExpense;
        }

        LINE_5415.notes = "Contingency for miscellaneous expenses.";

        //	5416 - Title Clearing Fees
        const LINE_5416 = {
            recurring_items: monthly_admin_management_fee * parseInt(period),
            non_recurring_items: Math.ceil(set_up_fee / 10) * 10,
            notes: currencyFormat(monthly_admin_management_fee) +
                "/mo Admin Mgmt Fee, " +
                currencyFormat(set_up_fee) +
                " custody fee."
        };

        // 5414 - Utilities

        const LINE_5414 = {
            recurring_items: 0,
            non_recurring_items: 0,
            notes: ""
        };

        if (type !== "land") {
            let value = LINE_5414.recurring_items;
            // .10 per sq. ft.; round up to the nearest ten
            let value_per_sqft = 0.1;
            let value_per_sqft_after_1000 = 0.07;
            let current_sqft = building_size;
            let first_1000_sqft_value = 150;
            let paid_sqft = 1000;
            if (type === "commercial" || type === "multi-family") {
                value = current_sqft * value_per_sqft;
            }

            if (type === "sfr") {
                value = first_1000_sqft_value;
                current_sqft -= paid_sqft;

                if (current_sqft > 0) {
                    // BUILT BEFORE 1980
                    // .10 for every sq. ft. after 1000
                    if (year_built > 1980) {
                        value_per_sqft = value_per_sqft_after_1000;
                    }

                    value = value + current_sqft * value_per_sqft;
                }
            }

            value = Math.ceil(value / 10) * 10;
            LINE_5414.notes =
                currencyFormat(value) +
                "/month - estimated based on US averages.";

            LINE_5414.recurring_items = value * period;
        }

        //	5255 - Due Diligence
        //	3500 static Fee
        //	Pre-Seizure Package + Custody Passthrough Expenses

        const due_diligence_static_fee = 3500;
        const LINE_5255 = {
            non_recurring_items: due_diligence_static_fee,
            notes: "Pre-Acquisition Analysis Package + Custody Passthrough Expenses"
        };

        //	5411 - Cleaning
        //	If the property has occupants, this should be $1,500.00
        //	Note should read: "Contingency for tenant move-out cleaning fees

        const occupied_property_fixed_fees = 1500;
        const LINE_5411 = {
            non_recurring_items: 0,
            notes: ""
        };

        if (parseInt(property_management_occupancy_status) === 1) {
            LINE_5411.non_recurring_items = occupied_property_fixed_fees;
            LINE_5411.notes = "Contingency for tenant move-out cleaning fees.";
        }

        //	5421 - Environmental Remediation & Assessment
        //	$3,500 for land only.
        //	Note should read: "Based on US averages."

        const LINE_5421 = {
            non_recurring_items: 0,
            notes: ""
        };

        if (type !== "land") {
            // LBP ABATEMENT APPLIES TO:
            // - ALL OF RESIDENTIAL
            // - ALL MULTI-FAMILY
            // - COMMERCIAL, SUB-TYPE Mixed-Use
            if (
                type === "sfr" ||
                type === "multi-family" ||
                (type === "commercial" && type_secondary.toString() === "34")
            ) {
                if (year_built < 1960) {
                    LINE_5421.non_recurring_items = 12800;
                    LINE_5421.notes = "Lead based paint abatement estimate";
                }
                else if (year_built >= 1960 && year_built <= 1978) {
                    LINE_5421.non_recurring_items = 550;
                    LINE_5421.notes = "Lead based paint assessment estimate";
                }
                else {
                    LINE_5421.non_recurring_items = 0;
                    LINE_5421.notes = "";
                }
            }
        }

        //	 5256 - Survey & Testing

        const LINE_5256 = {
            non_recurring_items: 0,
            notes: ""
        };

        if (type === "land") {
            if (lot_size >= 100) {
                LINE_5256.non_recurring_items = 8000;
            }
            else if (lot_size >= 50) {
                LINE_5256.non_recurring_items = 5000;
            }
            else if (lot_size >= 10) {
                LINE_5256.non_recurring_items = 3500;
            }
            if (lot_size >= 10) {
                LINE_5256.notes = "Estimate based on US averages.";
            }
        }

        //	5258 - Appraisal Fees
        const LINE_5258 = {
            non_recurring_items: Math.ceil(appraisal_fee / 10) * 10,
            notes: "Based on US averages for full narrative appraisal."
        };
        if (value_current_appraised >= 2500000) {
            LINE_5258.notes =
                "Based on US averages for full narrative appraisal and corroborating appraisal.";
        }

        //	5410 - Maintenance and Repairs
        //	If year_built < 1960 then $12,800, If year_built >= 1960 && < 1978 then $550, otherwise leave this $0
        const LINE_5410 = {
            non_recurring_items: 0,
            recurring_items: 0,
            notes: ""
        };
        const maintenance_fees = 0.02;
        const before_1978_maintenace_fees = 0.0425;
        let merp_note = "";
        let value_5410_non_recurring = LINE_5410.non_recurring_items;
        if (type === "commercial" || type === "multi-family") {
            if (year_built < 1978) {
                // .0425 per square foot per month

                value_5410_non_recurring =
                    before_1978_maintenace_fees *
                    parseFloat(period) *
                    parseFloat(building_size);
                merp_note =
                    " + Annual Allocated Cost per SqFt for M.E.P. & Roof Systems";
            }
            else {
                value_5410_non_recurring =
                    maintenance_fees *
                    parseFloat(period) *
                    parseFloat(building_size);
                merp_note =
                    " + Annual Allocated Cost per SqFt for M.E.P. & Roof Systems";
            }
        }

        LINE_5410.recurring_items =
            Math.ceil((inspection_fee * period) / 10) * 10;
        LINE_5410.non_recurring_items =
            Math.ceil(value_5410_non_recurring / 10) * 10;
        LINE_5410.notes =
            currencyFormat(inspection_fee) +
            "/month Inspections" +
            merp_note +
            ".";

        //	5253 - Closing Costs
        const LINE_5253 = {
            non_recurring_items: 0,
            notes: ""
        };

        let closing_cost = 1500;
        const closing_percentage = 0.0185;

        closing_cost =
            closing_cost +
            value_current_appraised * closing_percentage +
            realtor_disposition;
        LINE_5253.non_recurring_items = Math.round(closing_cost / 10) * 10;
        LINE_5253.notes =
            "Closing costs estimated at $1,500 for title and recording costs + 1.85% of appraised value disposition fee per the fee schedule + realtor disposition fee.";

        const newlyPopulatedBudgetData = {
            ...BudgetData,
            ["OPERATING EXPENSES"]: {
                ...BudgetData["OPERATING EXPENSES"],
                5255: {
                    ...BudgetData["OPERATING EXPENSES"][5255],
                    ...LINE_5255
                },
                5405: {
                    ...BudgetData["OPERATING EXPENSES"][5405],
                    ...LINE_5405
                },
                5410: {
                    ...BudgetData["OPERATING EXPENSES"][5410],
                    ...LINE_5410
                },
                5411: {
                    ...BudgetData["OPERATING EXPENSES"][5411],
                    ...LINE_5411
                },
                5413: {
                    ...BudgetData["OPERATING EXPENSES"][5413],
                    ...LINE_5413
                },
                5414: {
                    ...BudgetData["OPERATING EXPENSES"][5414],
                    ...LINE_5414
                },
                5415: {
                    ...BudgetData["OPERATING EXPENSES"][5415],
                    ...LINE_5415
                },
                5416: {
                    ...BudgetData["OPERATING EXPENSES"][5416],
                    ...LINE_5416
                }
            },
            ["RESOLUTION EXPENSES"]: {
                ...BudgetData["RESOLUTION EXPENSES"],
                5253: {
                    ...BudgetData["RESOLUTION EXPENSES"][5253],
                    ...LINE_5253
                },
                5256: {
                    ...BudgetData["RESOLUTION EXPENSES"][5256],
                    ...LINE_5256
                },
                5258: {
                    ...BudgetData["RESOLUTION EXPENSES"][5258],
                    ...LINE_5258
                },
                5421: {
                    ...BudgetData["RESOLUTION EXPENSES"][5421],
                    ...LINE_5421
                }
            }
        };
        dispatch(updateBudgetData(newlyPopulatedBudgetData));
        dispatch(setAlert("Budget Populated", "success"));
        return true;
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
        return false;
    }
    finally {
        dispatch({ type: REMOVE_LOADING_BUDGET });
    }
};

// Set budget contact id.
